module.exports = __webpack_public_path__ + "img/GreekTechHypastpist2_ua.d4405569.webp";